import { useMyBalance } from "api/Client/balance";
import { Spinner } from "components";
import useCurrentLocation from "Hooks/useCurrentLocation";
import useViewTransitionNavigate from "Hooks/useViewTransitionNavigate";
import { useEffect, useRef, useState } from "react";
import { AiFillAndroid } from "react-icons/ai";
import { BsFillSendArrowUpFill } from "react-icons/bs";
import { FcBusinessman } from "react-icons/fc";
import { IoExit, IoSendSharp } from "react-icons/io5";
import { MdNotificationsActive } from "react-icons/md";
import { PiPasswordFill } from "react-icons/pi";
import { RiMenuFoldLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { setBalance } from "store/reducers/balanceReducer";

const links = [
  {
    title: "إشعارات التطبيق",
    url: "/control-panel/notifications",
    icon: <MdNotificationsActive className="text-white" />,
  },
  {
    title: "تغير كلمة المرور",
    url: "/control-panel/change-password",
    icon: <PiPasswordFill className="text-white" />,
  },
  {
    title: "خروج",
    url: "/logout",
    icon: <IoExit className="text-white" />,
  },
];

export default function Account() {
  const currentLocation = useCurrentLocation();
  const navigate = useViewTransitionNavigate();
  const {
    data: myBalance,
    isFetching: myBalanceIsLoading,
    isSuccess: myBalanceIsSuccess,
  } = useMyBalance();
  const { name, roles } = useSelector((state) => state.auth);
  const { isBroker } = useSelector((state) => state.balance);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null); // لربط العنصر بالـ dropdown
  const buttonRef = useRef(null); // لربط العنصر بالزر
  const dispatch = useDispatch();
  const toggleDropdown = () => {
    setIsOpen((prevState) => !prevState);
  };

  useEffect(() => {
    if (myBalanceIsSuccess) {
      dispatch(
        setBalance({
          currency: myBalance?.data.currency,
          balance: myBalance?.data.balance,
          isBroker: myBalance?.data.isBroker,
          centerName: myBalance?.data.centerName,
          address: myBalance?.data.address,
          city: myBalance?.data.city,
        })
      );
    }
  }, [myBalance]);

  // إغلاق الـ dropdown عند النقر في أي مكان آخر
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    // إضافة مستمع للنقر
    document.addEventListener("mousedown", handleClickOutside);

    // إزالة المستمع عند تفريغ الـ component
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="hidden lg:inline-flex relative py-1">
      <button
        ref={buttonRef}
        type="button"
        onClick={toggleDropdown}
        className="bg-green-500_ hover:bg-green-700_ text-white shadow-md items-center p-2 w-10 h-10 justify-center text-sm  rounded-lg duration-500"
      >
        <RiMenuFoldLine
          className={`text-2xl -rotate-90 ${isOpen && "-scale-x-100"} `}
        />
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <div
          ref={dropdownRef}
          id="dropdownHover"
          className="absolute z-10 bg-mainLight/85 backdrop-blur-sm divide-y divide-white rounded-lg shadow-lg w-60 top-full right-0 p-4"
        >
          <div className="flex flex-col items-center pb-2">
            <FcBusinessman
              className="text-6xl cursor-pointer hover:opacity-80"
              onClick={() => {
                navigate("/control-panel/my-profile");
                setIsOpen(false);
              }}
            />
            <div className="flex flex-col text-center w-full px-4 text-white">
              <h1 className="text-lg font-bold">{name}</h1>
              {/* <h1 className="text-xs text-gray-200">{roles[0]?.name}</h1> */}
              <h1 className="bg-green-500_ text-2xl mt-2 py-0.5 px-2 rounded-lg shadow-md shadow-green-500/10_">
                <span dir="ltr" className="text-white">
                  {myBalanceIsLoading && (
                    <span className="bg-white w-7 h-7 grid place-items-center mx-auto mb-1 rounded-md">
                      <Spinner xs />
                    </span>
                  )}

                  {myBalanceIsSuccess && !myBalanceIsLoading && (
                    <span>
                      {Number(myBalance?.data.balance).toLocaleString()}{" "}
                      <span className="text-sm">
                        {myBalance?.data.currency}
                      </span>
                    </span>
                  )}
                </span>
              </h1>
            </div>
          </div>
          <ul className="flex-col px-4 flex text-white gap-1 mt-2 pt-4">
            {!!isBroker && (
              <li>
                <div
                  onClick={() => {
                    navigate("/control-panel/transfer");
                    setIsOpen(false);
                  }}
                  // to={link.url}
                  className={`px-2 py-2 rounded-md text-nowrap cursor-pointer hover:bg-white/15 duration-700 flex gap-2 items-center group text-sm ${
                    currentLocation == "/control-panel/transfer" &&
                    "bg-white/15"
                  }`}
                >
                  <BsFillSendArrowUpFill className="text-xl duration-700 group-hover:scale-125" />
                  ارسال
                </div>
              </li>
            )}

            {links.map((link, index) => (
              <li key={index}>
                <div
                  onClick={() => {
                    navigate(link.url);
                    setIsOpen(false);
                  }}
                  // to={link.url}
                  className={`px-2 py-2 rounded-md text-nowrap cursor-pointer hover:bg-white/15 duration-700 flex gap-2 items-center group text-sm ${
                    currentLocation == link.url && "bg-white/15"
                  }`}
                >
                  <p className="text-xl duration-700 group-hover:scale-125">
                    {link.icon}
                  </p>
                  {link.title}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
